<template>
    <span>
        <div class="flex flex-col w-full h-52 items-center justify-center splash-screen-loading-box" v-if="loading">
            <n-spin :size="80" />
        </div>
        <div v-else class="page">
            <n-form
                ref="formRef"
                :model="storeEvents.activityConfiguration"
                :rules="rules"
                :size="size"
                label-placement="top"
            >
                <n-grid :x-gap="24">
                  
                    <n-grid-item :span="12" >
                        <n-form-item-gi :label="$t('gm.dashboards.type')" path="game">
                            <n-select 
                                required
                                v-model:value="storeEvents.activityConfiguration.game"
                                :placeholder="$t('gm.dashboards.placeholder_type')"
                                :options="settingsOptions"
                                @update:value="setCluedoAISettings"
                            >
                            </n-select>
                        </n-form-item-gi>
                        <n-grid :x-gap="5" >
                            <n-form-item-gi :span="8" :label="$t('gm.dashboards.acts')" path="acts" v-if="storeEvents.eventSelected.activity.code == 'CAI'">
                                <ul>
                                    <li v-for="item in cluedoAISetting" :key="item">{{ item.name }}</li>
                                </ul>
                            </n-form-item-gi>
                        </n-grid >
                        <n-grid :x-gap="24" v-if="storeEvents.activityConfiguration.type == 'MAP'">
                            <n-form-item-gi :span="10" :label="$t('gm.dashboards.latitude')" path="latitude">
                                <n-input-number :disabled="true" v-model:value="storeEvents.activityConfiguration.latitude" clearable />
                            </n-form-item-gi>
                            <n-form-item-gi  :span="10" :label="$t('gm.dashboards.longitude')" path="longitude">
                                <n-input-number :disabled="true" v-model:value="storeEvents.activityConfiguration.longitude" clearable />
                            </n-form-item-gi>
                            <n-form-item-gi :span="4">
                                <n-button v-if="mapStore.activeMarkerId !== 'initMarker'"  type="info" @click="activateAddMarker('initMarker', t('gm.ipadHunt.initial_position'), 'red')" ghost>
                                    <Icon :size="20" :name="LocateIcon"/>
                                </n-button>
                                <n-button  v-else type="info" @click="mapStore.activeMarkerId = null">
                                    <Icon :size="20" :name="LocateIcon"/>
                                </n-button>
                            </n-form-item-gi>
                        </n-grid>
                        <n-grid :x-gap="24" v-if="storeEvents.activityConfiguration.type == 'MAP'">
                            <n-form-item-gi :span="10" :label="$t('gm.dashboards.finish_latitude')" path="finish_latitude">
                                <n-input-number :disabled="true" v-model:value="storeEvents.activityConfiguration.finish_latitude" clearable />
                            </n-form-item-gi>
                            <n-form-item-gi  :span="10" :label="$t('gm.dashboards.finish_longitude')" path="finish_longitude">
                                <n-input-number :disabled="true" v-model:value="storeEvents.activityConfiguration.finish_longitude" clearable />
                            </n-form-item-gi>
                            <n-form-item-gi :span="4">
                                <n-button v-if="mapStore.activeMarkerId !== 'finishMarker'"  type="info" @click="activateAddMarker('finishMarker', 'Posición final', 'green')" ghost>
                                    <Icon :size="20" :name="LocateIcon"/>
                                </n-button>
                                <n-button  v-else type="info" @click="mapStore.activeMarkerId = null">
                                    <Icon :size="20" :name="LocateIcon"/>
                                </n-button>
                            </n-form-item-gi>
                        </n-grid>
                    </n-grid-item>
                    
                    <n-grid-item :span="12" >
                        <n-form-item-gi :label="$t('gm.dashboards.type_game')" path="type">
                            <n-radio-group v-model:value="storeEvents.activityConfiguration.type" name="radiogroup">
                                    <n-space>
                                        <n-radio
                                            v-for="type in typeEvent"
                                            :key="type.value"
                                            :value="type.value"
                                            :label="type.label"
                                        />
                                    </n-space>
                                </n-radio-group>
                        </n-form-item-gi>
                        <n-form-item-gi v-if="storeEvents.activityConfiguration.type == 'MAP'" :label="$t('gm.dashboards.map')" path="map">
                            <Map style="height: 530px;" :zoom="12" :inputAddress="true" />
                        </n-form-item-gi>
                    </n-grid-item>
                </n-grid>
            </n-form>
        </div>
    </span>
</template>

<script lang="ts" setup>
import Icon from "@/components/common/Icon.vue"
import { NForm, NGrid, NFormItemGi, NSelect, NSpin,NGridItem, NSpace, NRadioGroup, NRadio, NInputNumber, NButton} from "naive-ui"
import { computed, onMounted, ref, Ref, nextTick, watch } from "vue"
import { type LabelPlacement, type Size, FormInst } from "naive-ui/es/form/src/interface"
import { useRoute, useRouter } from "vue-router"
import { useEventsStore } from "@/stores/apps/events"
import { axiosToken, fetchPromiseAll } from "@/utils/http";
import type { AxiosResponse } from "axios";
import { useContentStore } from "@/stores/apps/content"
import { useCluedoAIStore } from "@/stores/apps/cluedo_ai"
import { useStoreI18n } from "@/composables/useStoreI18n"
import Map from "@/components/common/Map.vue"
import { useMapStore } from "@/stores/map"
import { parseMapCoords } from "@/utils/mapCenter"

const mapStore = useMapStore()
const { t } = useStoreI18n()
const storeEvents = useEventsStore()
const storeContent = useContentStore()
const storeCluedoAI = useCluedoAIStore()
const typeEvent = ref([{label: "Online", value: "ONLINE"}, {label: "QR", value: "QR"}, {label: "Map", value: "MAP"}])

const route = useRoute()
const size = ref<Size | undefined>("medium")
const cluedoAISetting = ref([]);

const settings = computed(() => { return storeContent.content.cluedo_ai_settings})

const LocateIcon = "ion:locate-outline"

let settingsOptions = []
const loading = ref(true)
onMounted( async () => {
    storeEvents.activityConfiguration = {game: "", type: "", activity_formRef: formRef, latitude: 0, longitude: 0, finish_latitude: 0, finish_longitude: 0}
    if(route.params.api_key)
    {
        await fetchPromiseAll([
            storeCluedoAI.fetchCluedoAIData(String(route.params.api_key)),
            storeContent.getAllMultipleContent(["cluedo_ai_act"]),
            storeContent.getAllMultipleContent(["cluedo_ai_settings"]),
        ])
        loadCluedoAIForm()
    } else {
        await fetchPromiseAll([
            storeContent.getAllMultipleContent(["cluedo_ai_act"]),
            storeContent.getAllMultipleContent(["cluedo_ai_settings"]),
        ])
    }
    if( storeEvents.eventSelected.activity.code == 'CAI')
    {
        settingsOptions = settings.value.filter(e=> !e.use_store).map(v => ({label: v.name, value: v.id.toString()}))
    }
    else
    {
        settingsOptions = settings.value.filter(e=> e.use_store).map(v => ({label: v.name, value: v.id.toString()}))
    }

    loading.value = false
});

const markerToAdd = ref({id: "", title: "", pos: {lat: 0, lng: 0}, color: ""})

watch(() => mapStore.mapInstance, (newVal) => {
    if(newVal) 
    {
        mapStore.mapInstance.addListener('click', (event: google.maps.MapMouseEvent) => {
            if(mapStore.activeMarkerId == null)
            {
                return
            }
            if (event.latLng) {
                markerToAdd.value.pos = {lat: event.latLng.lat(), lng: event.latLng.lng()}
                mapStore.placeMarker(markerToAdd.value.id, markerToAdd.value.title, markerToAdd.value.pos, markerToAdd.value.color)
                saveMarkerCoordinates(markerToAdd.value.id, event.latLng.lat(), event.latLng.lng())
            }
        })
    }
})

const saveMarkerCoordinates = (markerId: string, lat: number, lng: number) => {
    if (markerId === 'initMarker') {
        storeEvents.activityConfiguration.latitude = lat
        storeEvents.activityConfiguration.longitude = lng
    } else if (markerId === 'finishMarker') {
        storeEvents.activityConfiguration.finish_latitude = lat
        storeEvents.activityConfiguration.finish_longitude = lng
    }
    mapStore.activeMarkerId = null
}

const loadCluedoAIForm = () => 
{
    if(storeCluedoAI.cluedoAIData.game != undefined)
    {
        storeEvents.activityConfiguration.game = storeCluedoAI.cluedoAIData.game.id.toString()
        setCluedoAISettings();
    }
    console.log(storeCluedoAI.cluedoAIData)
    const initCoords = parseMapCoords(
        storeCluedoAI.cluedoAIData.latitude,
        storeCluedoAI.cluedoAIData.longitude
    )
    const finishCoords = parseMapCoords(
        storeCluedoAI.cluedoAIData.finish_latitude,
        storeCluedoAI.cluedoAIData.finish_longitude
    )
    storeEvents.activityConfiguration.latitude = initCoords?.lat ?? 0
    storeEvents.activityConfiguration.longitude = initCoords?.lng ?? 0
    storeEvents.activityConfiguration.finish_latitude = finishCoords?.lat ?? 0
    storeEvents.activityConfiguration.finish_longitude = finishCoords?.lng ?? 0
    storeEvents.activityConfiguration.type = storeCluedoAI.cluedoAIData.type

    if (initCoords) {
        mapStore.placeMarker('initMarker', t('gm.ipadHunt.initial_position'), initCoords, 'green')
    }
    if (finishCoords) {
        mapStore.placeMarker('finishMarker', t('gm.ipadHunt.finish_position'), finishCoords, 'red')
    }
    mapStore.activeMarkerId = null
    mapStore.setCenterFromPreferred(
        storeCluedoAI.cluedoAIData.latitude,
        storeCluedoAI.cluedoAIData.longitude
    )
}


const cluedoAISettingSelected = ref({id: 0, name: "", acts: []});

const setCluedoAISettings = () => 
{
    cluedoAISetting.value = []
    nextTick(() => {
        cluedoAISettingSelected.value = storeContent.content.cluedo_ai_settings.find( (v:any) => v.id == parseInt(storeEvents.activityConfiguration.game))

        cluedoAISettingSelected.value.order.forEach(e => {
            cluedoAISetting.value.push(storeContent.content.cluedo_ai_act.find( (v:any) => v.id == e))
        });
    });
}

const formRef = ref<FormInst | null>(null)
const rules = {
        game: {
            required: true,
            trigger: ['blur', 'change'],
            message: t('gm.dashboards.placeholder_template')
        },
    };

const activateAddMarker = (id: string, title: string, color: string) => {
    markerToAdd.value.id = id
    markerToAdd.value.title = title
    markerToAdd.value.color = color
    mapStore.activeMarkerId = id
}

</script>

<style lang="scss" scoped>
.components-list {
	grid-template-columns: none;
}
.card-css {
    background-color: var(--bg-color);
}
</style>
